import mainReducers from './reducers';
import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware as createRouterMiddleware } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import { composeWithDevTools } from 'redux-devtools-extension';

export const browserHistory = createBrowserHistory();

const reduxOptions = { name: 'MainStore', serialize: true };

const composeEnhancers = (process.env.NODE_ENV === 'development' && composeWithDevTools(reduxOptions)) || compose;
const routerMiddleware = createRouterMiddleware(browserHistory);
const enhancer = composeEnhancers(
  applyMiddleware(thunk, routerMiddleware)
);

const store = createStore(mainReducers, enhancer);

if (module.hot) {
  module.hot.accept('./reducers', () => {
    const nextRootReducer = require('./reducers');
    store.replaceReducer(nextRootReducer);
  });
}

export default store;
